/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminUpdateTeamOwnerRequest
 */
export interface AdminUpdateTeamOwnerRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateTeamOwnerRequest
     */
    teamMemberId?: string;
}

export function AdminUpdateTeamOwnerRequestFromJSON(json: any): AdminUpdateTeamOwnerRequest {
    return AdminUpdateTeamOwnerRequestFromJSONTyped(json, false);
}

export function AdminUpdateTeamOwnerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateTeamOwnerRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teamMemberId': !exists(json, 'teamMemberId') ? undefined : json['teamMemberId'],
    };
}

export function AdminUpdateTeamOwnerRequestToJSON(value?: AdminUpdateTeamOwnerRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teamMemberId': value.teamMemberId,
    };
}


